export default "__VITE_ASSET__M4c0XY_M__"